import { combineReducers } from "redux";
import firebaseUser from "./firebaseUser";
import clientList from "./clientList";
import storeUser from "./storeUser";
import products from "./products";
import store from "./store.ts";
import storeOrders from "./storeOrders";
import headerVisible from "./headerVisible";
import isMobile from "./isMobile";
import community from "./community";
const rootReducer = combineReducers({
  firebaseUser,
  clientList,
  storeUser,
  products,
  store,
  storeOrders,
  headerVisible,
  isMobile,
  community
});

export default rootReducer;
